import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { Typography } from '../Typography/Typography.js';
import { remapNotificationBadgeProp } from './TabItem.mappers.js';

var _excluded = ["isActive", "label", "leadingAsset", "trailingAsset", "size", "lineClamp", "flex", "width"];
var TabIndicator = /*#__PURE__*/React.memo(function (_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement(Box, {
    bottom: "0",
    left: "0",
    right: "0",
    position: "absolute",
    width: "100%",
    height: size === 'm' ? '4px' : '2px',
    backgroundColor: "product.primary",
    borderRadius: size === 'm' ? ['8', '8', '0', '0'] : ['2', '2', '0', '0']
  });
});
TabIndicator.displayName = 'TabIndicator';
var mapAlignment = function mapAlignment(trailingAsset) {
  return /*#__PURE__*/React.cloneElement(trailingAsset, remapNotificationBadgeProp(trailingAsset.props));
};
var Tab = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var isActive = props.isActive,
    label = props.label,
    leadingAsset = props.leadingAsset,
    trailingAsset = props.trailingAsset,
    size = props.size,
    lineClamp = props.lineClamp,
    flex = props.flex,
    width = props.width,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    minHeight: "44px",
    position: "relative",
    flex: flex,
    px: width === 'content-fit' ? '4' : '16' // xs for cutoff issue in tab focus at start or end index
    ,
    justifyContent: "center",
    alignItems: "center",
    scrollSnapAlign: "start"
  }, /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    ref: ref,
    as: "button",
    role: "tab",
    py: "4",
    px: "12",
    borderRadius: "24",
    interactive: "product.primary",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    tabIndex: isActive ? 0 : -1,
    textColor: isActive ? 'product.primary' : 'base.subtle',
    "aria-selected": isActive
  }), leadingAsset && /*#__PURE__*/React.createElement(Icon, _extends({
    me: "4",
    size: size === 'm' ? '20' : '16',
    id: leadingAsset.id
  }, leadingAsset.label ? {
    label: leadingAsset.label
  } : {})), /*#__PURE__*/React.createElement(Typography, {
    variant: size === 's' ? 'body-s-strong' : 'body-default-strong',
    textAlign: leadingAsset ? 'start' : 'center',
    lineClamp: lineClamp
  }, label), trailingAsset && mapAlignment(trailingAsset)), isActive && /*#__PURE__*/React.createElement(TabIndicator, {
    size: size
  }));
});
var TabMemoized = /*#__PURE__*/React.memo(Tab);
TabMemoized.displayName = 'TabItem';
var TabItem = /*#__PURE__*/React.memo(function (props) {
  return Tab(props);
});
TabItem.displayName = 'TabItem';

export { TabMemoized as Tab, TabItem };
//# sourceMappingURL=TabItem.js.map
